"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEntityActionCreator = exports.setEntitiesActionCreator = exports.addEntityActionCreator = void 0;
const utils_1 = require("../../../store/actions/utils");
const addEntityActionCreator = (actionType) => (entity) => (0, utils_1.createAction)(actionType, { entity });
exports.addEntityActionCreator = addEntityActionCreator;
const setEntitiesActionCreator = (actionType) => (entities) => (0, utils_1.createAction)(actionType, { entities });
exports.setEntitiesActionCreator = setEntitiesActionCreator;
const updateEntityActionCreator = (actionType) => (id, changes) => (0, utils_1.createAction)(actionType, { id, changes });
exports.updateEntityActionCreator = updateEntityActionCreator;
